import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetConfigurations = (params: any) =>
    GET_ENC(`${BASE_URL}/api/SystemConfiguration/GetConfigurations?` + params, null);

export const CreateConfiguration = (data: any) =>
  POST_ENC(`${BASE_URL}/api/SystemConfiguration/Create`, data);

export const UpdateConfiguration = (data: any) =>
  POST_ENC(`${BASE_URL}/api/SystemConfiguration/Update`, data);    

export const GetSystemConfigurationById = (params: any) =>
  GET_ENC(`${BASE_URL}/api/SystemConfiguration/GetSystemConfiguration?` + params, null);

